import { makeAutoObservable } from 'mobx';
import { StatementCategoryOperationEnum } from '../../models';
import { StatementCategoryModel } from '../../models/StatementCategoryModel';
import { TextInputLibrary } from './FormLibraries/TextInputLibrary';

export class CategoryComponentLibrary
{
	public Category: StatementCategoryModel;

	public Operation: StatementCategoryOperationEnum;
	public setOperation(op: StatementCategoryOperationEnum) { this.Operation = op; }

	public Phone: TextInputLibrary;
	public Email: TextInputLibrary;
	public Web: TextInputLibrary;


	constructor(category: StatementCategoryModel, operation: StatementCategoryOperationEnum)
	{
		this.Category = category;
		this.Operation = operation;

		this.Phone = new TextInputLibrary("^[ �-��-�0-9.,()�+-]{11,60}$", 60, ()=>true);
		this.Email = new TextInputLibrary("^.{1,64}@.{4,255}$", 320, () => true);
		this.Web = new TextInputLibrary("^https?:\\/\\/.+$", 2000, () => true);

		makeAutoObservable(this,
			{
				Category: false
			}, { autoBind: true });
	}
}
